import { getPlatformURL } from "utils/helpers"

export function getSuraasaPlusLandingPageUrl() {
  return getPlatformURL("suraasa", "/suraasa-plus")
}
